const getEnvValue = name => globalThis._env_?.[name];

export default getEnvValue;
